import * as _ from 'lodash';
// select distinct source from items;
// public enum AssetFilterType
// {
// 	NestedChannel,
// 	ClipGroup,
// 	LiveProgramAssets,
// 	VODFileAssets,
// 	Image,
// 	Transitions,
// 	Collection, // useful for filtering out all collection types below
// 	Series,
// 	Season,
// 	Extra,
// 	Trailer,
// 	None
// }

// AssetFilterType LiveProgramAssets encompasses LiveEncoder and LiveStreamManager source types
// AssetFilterType VODFileAssets encompasses all source types except ClipGroup, NestedChannel, and LiveEncoder and LiveStreamManager
export enum AssetFilterType {
  NestedChannel = 'NestedChannel', // includes source types: "NestedChannel"
  ClipGroup = 'ClipGroup', // includes source types: "ClipGroup"
  LiveProgramAssets = 'LiveProgramAssets', // includes source types: "LiveEncoder" and "LiveStreamManager"
  VODFileAssets = 'VODFileAssets', // includes source types: "SubClip" "FeedIngest" "AdVariant" and "Ingest"
  Image = 'Image', // allows user to filter by schemaType = 'Image'
  Transitions = 'Transitions', // Allows user to filter by schemaType = 'Transitions'
  Collection = 'Collection',
  Series = 'Series',
  Season = 'Season',
  Extra = 'Extra',
  Trailer = 'Trailer',
  LiveEvent = 'LiveEvent',
}

export interface AssetFilterTypeOptions {
  id: AssetFilterType;
  name: string;
}

export const AssetFilterTypeOptions: AssetFilterTypeOptions[] = [
  { id: AssetFilterType.NestedChannel, name: 'Nested/Collections' },
  { id: AssetFilterType.ClipGroup, name: 'Clip Groups' },
  { id: AssetFilterType.LiveProgramAssets, name: 'Live Program Assets' },
  { id: AssetFilterType.VODFileAssets, name: 'VOD File Assets' },
  { id: AssetFilterType.Series, name: 'Series' },
  { id: AssetFilterType.Season, name: 'Season' },
  { id: AssetFilterType.Extra, name: 'Extra' },
  { id: AssetFilterType.Trailer, name: 'Trailer' },
  { id: AssetFilterType.LiveEvent, name: 'LiveEvent' },
];

// all AssetFilterTypeOptions above plus a filter to return just Images
export const AssetFilterTypeOptionsExtended: AssetFilterTypeOptions[] = [
  { id: AssetFilterType.NestedChannel, name: 'Nested/Collections' },
  { id: AssetFilterType.ClipGroup, name: 'Clip Groups' },
  { id: AssetFilterType.LiveProgramAssets, name: 'Live Program Assets' },
  { id: AssetFilterType.VODFileAssets, name: 'VOD File Assets' },
  { id: AssetFilterType.Transitions, name: 'Transitions' },
  { id: AssetFilterType.Image, name: 'Image' },
  { id: AssetFilterType.LiveEvent, name: 'LiveEvent' },
  // { id: AssetFilterType.Collection, name: 'Collection' },
  // { id: AssetFilterType.Series, name: 'Series' },
  // { id: AssetFilterType.Season, name: 'Season' },
  // { id: AssetFilterType.Extra, name: 'Extra' },
];

export const GetAssetFilterTypeOptions = (type: AssetFilterType | AssetFilterType[]) => {
  if (_.isArray(type)) {
    const types: AssetFilterType[] = type;
    return AssetFilterTypeOptionsExtended.filter((a) => types.findIndex((t) => t === a.id) > -1);
  }
  return AssetFilterTypeOptionsExtended.filter((a) => a.id === type);
};
